import { render, staticRenderFns } from "./CarTransfer.vue?vue&type=template&id=628db2ef&scoped=true&"
import script from "./CarTransfer.vue?vue&type=script&lang=js&"
export * from "./CarTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628db2ef",
  null
  
)

export default component.exports